import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useUsersData = () => {
    const getUsersData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}users${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postUsersData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}users${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}users${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putUsersData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}users${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchUsersData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}users${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteUsersData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}users${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getUsersData,
        postUsersData,
        putUsersData,
        patchUsersData,
        deleteUsersData
    };

};